import React, { useState, useEffect, useContext } from 'react';
import handleSubmitForCheckbox from "../../Controller/AssignFormController/AssignFormController";
import ModuleService from "../../../Setup/controller/ModuleController/ModuleController";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import FormPermissionService from "../../../Setup/controller/FormPermissionController/FormPermissionController";

function FormListPage() {
    const navigate = useNavigate();


    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };
    const RoleID = localStorage.getItem('RoleID');
    const FormAction = "/AssignModule";
    FormPermissionService.HasPerimssion(redirectCallback, RoleID, FormAction);


    const [formList, setForms] = useState([]);
    const [AssignedformList, setAssignedForms] = useState([]);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }
    const getIDFromQueryString = () => {
        const searchParams = new URLSearchParams(window.location.search);
        return searchParams.get('ClientID');
    };
    const [ModuleList, setModules] = useState([]);
    const ClientID = getIDFromQueryString();
    useEffect(() => {
        async function fetchModules() {
            try {
                debugger;
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const modulesData = await ModuleService.GetCompanyModules(redirectCallback, "en", ClientID);
                setModules(modulesData);
            } catch (error) {
                console.error('Error fetching Modules:', error);
            }
        }
        fetchModules();
    }, []);

    return (
        <div>
            <div className="main-content-header">
                <h1>Assign Modules</h1>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <div className="row mb-3">
                                <Link className='btn btn-primary' to={`/CreateAssignModule?ClientID=${ClientID}`}>
                                    <i className='bi bi-plus-lg'></i>
                                    Assign new Module
                                </Link>
                                <Link className='btn btn-secondary' to={`/ClientList`}> Back </Link>

                            </div>
                            <div className="table-responsive">
                                <table className="table m-0 table-hover">
                                    <thead>
                                        <tr>
                                            <th>Module Name</th>
                                            <th>Module Type</th>

                                        </tr>
                                    </thead><tbody>

                                        {
                                            ModuleList.map(module => (
                                                <tr>
                                                    <td>{module.vc_ModuleName}</td>
                                                    <td>{module.vc_ModuleType}</td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
}

export default FormListPage;
